import AboutData from "../data/AboutPageData"
import AboutLogo from "../assets/logos/masar-logo-about.jpg"
import AboutHeader from "../assets/images/AboutUs-Img.jpg"
import AboutSection from "../features/aboutUs/AboutSection";
import { useTranslation } from 'react-i18next';
import { useMetadata } from "../hooks/useMetadata";
// import { usePageTitle } from "../hooks/usePageTitle";

export default function AboutUs() {
    const { t, i18n } = useTranslation();
    // usePageTitle('AboutUs');
    useMetadata(i18n.language);


    return (
        <div className="aboutPage text-center text-md-start">
            <img src={AboutHeader} alt="about header" className="py-4 w-100" />
            <div className="container d-flex justify-content-between align-items-start flex-wrap">
                <h3 className="col-12 col-md-2 mt-2 c-darkOrange text-center-md" >{t("Who We are")}</h3>
                <p className="col-12 col-md mt-3 mt-md-5 px-5 ps-md-0 lh-lg">{i18n.language === "ar" ? AboutData.about : AboutData.about_en}</p>
                <img src={AboutLogo} alt="masar Logo" className="col-3 m-auto d-none d-md-block w-auto px-2" />
            </div>
            <div className="bg-light-beige-10 text-white mx-5 py-3 rounded">
                <AboutSection
                    headName={t("Our Vision")}
                    sectionName={i18n.language === "ar" ? AboutData.vision : AboutData.vision_en}
                />
            </div>
            <div className="mx-5 py-3 rounded">
                <AboutSection
                    headName={t("Our Goals")}
                    sectionName={i18n.language === "ar" ? AboutData.goal : AboutData.goal_en}
                />
            </div>
        </div>
    );
};